import { render, staticRenderFns } from "./growth_record.vue?vue&type=template&id=0526fa96"
import script from "./growth_record.vue?vue&type=script&lang=js"
export * from "./growth_record.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports